module.exports = __webpack_public_path__ + "static/media/banner-temp.1dae78c4.jpg";